// Create new custom select:
// var select = $(element).custom_select();
// Get value
// var value = $(element).custom_select('value');
// Set value
// var select = $(element).custom_select('value', value);
// Set onUpdate listener
// $(element).custom_select('onUpdate', function(){})
$(function () {
    var instances = {};

    $.fn.custom_select = function (action = null, value = null) {
        var instance;
        if (action === null) {
            instance = Object.assign({}, Select);
            instance.constructor(this);
            instances[instance.uuid] = instance;
            return this;
        } else {
            instance = instances[this.attr('data-uuid')];
            if (action === 'value') {
                if (value !== null) {
                    instance.updateValue(value);
                }
                return instance.value;
            }

            if (action === 'onUpdate' && typeof value === 'function' && instance) {
                instance.onUpdate(value);
                return this;
            }
        }
    };

    var Select = {
        el: null,
        uuid: '',
        listeners: [],
        opened: false,
        range_select: false,
        value: null,
        constructor: function (el) {
            this.el = el;
            this.listeners = [];
            this.uuid = Math.random().toString(36).slice(2);
            this.el.attr('data-uuid', this.uuid);
            this.range_select = this.el.attr('data-range') === 'true';
            this.init();
        },
        init: function () {
            if (this.range_select) {
                this.initRange();
            } else {
                this.initDefault();
            }
            this.setListeners();
        },
        initDefault: function () {
            this.close_on_select = this.el.attr('data-close-on-select') === 'true';
            // Initial choose option
            var checked = this.el.find('.select__option_checked');
            this.update(checked, !this.range_select, true);
        },
        initRange: function () {
            this.from_el = this.el.find('input[data-field="from"]');
            this.to_el = this.el.find('input[data-field="to"]');
            this.value = [this.from_el.val(), this.to_el.val()];
        },
        setDefaultListeners: function () {
            // Choose option
            this.el.on('click', '.select__option', e => {
                this.update($(e.target))
            });
        },
        setRangeListeners: function () {
            this.from_el.on('input', e => {
                if (!e.target.classList.contains('more-options__input-num')) {
                    this.value[0] = this.formatCurrency($(e.target));
                } else {
                    this.value[0] = $(e.target).val();
                }
                this.runListeners();
            });

            this.to_el.on('input', e => {
                if (!e.target.classList.contains('more-options__input-num')) {
                    this.value[1] = this.formatCurrency($(e.target));
                } else {
                    this.value[1] = $(e.target).val();
                }
                this.runListeners();
            })
        },
        setListeners: function () {
            // Open/close options list
            this.el.on('click', '.select__head', () => {
                this.el.toggleClass('select_open');
                this.opened = this.el.hasClass('select_open');

                if (this.opened) {
                    $(document).on('click.custom_select_outside' + this.uuid, e => {
                        if (!$(e.target).closest(this.el).length) {
                            this.el.toggleClass('select_open');
                            $(document).off('click.custom_select_outside' + this.uuid)
                            console.log(e);
                            $('.filter__block_price_and_room').removeClass('filter__select_price_open');
                        }
                    })
                } else {
                    $(document).off('click.custom_select_outside' + this.uuid)
                }
            })

            if (this.range_select) {
                this.setRangeListeners();
            } else {
                this.setDefaultListeners();
            }
        },
        update: function (option, range = false, initial = false) {
            this.updateHead(option);
            this.value = option.attr('data-value');

            if (!range) {
                this.el.find('.select__option').removeClass('select__option_checked');
                option.addClass('select__option_checked');
            }

            if (this.close_on_select) {
                this.el.removeClass('select_open');
                $(document).off('click.custom_select_outside' + this.uuid)
            }

            if (!initial) {
                this.runListeners();
            }
        },
        updateHead: function (option) {
            if (!this.range_select) {
                this.el.attr('data-value', option.attr('data-value'));
                this.el.find('.select__title').html(option.html());
            }
        },
        updateValue: function (value) {
            if (!this.range_select) {
                var option = this.el.find(`.select__option[data-value=${value}]`);
                this.updateHead(option);
                this.value = value;
            }
            this.runListeners();
        },
        onUpdate: function (closure) {
            this.listeners.push(closure);
        },
        runListeners: function () {
            this.listeners.forEach(closure => {
                closure(this);
            });
        },
        formatCurrency: function (input) {
            var input_val, clear_val = input.val().replace(/\D/g, '');
            if (clear_val === "") {
                input.val(clear_val);
                return;
            }
            input_val = Intl.NumberFormat('en').format(clear_val);
            input_val=input_val.replace(/[^\d ]/g, " ");
            input.val(input_val);
            return clear_val;
        }
    }
});
$(document).on('click', '.filter__block_price_and_room .select__head', function () {
    $('.filter__block_price_and_room').toggleClass('filter__select_price_open');
})
